import {Utils} from 'revlock-webutils';

const { addMonths, getMonthDiff, addWeeksTo } = Utils;

export const BillingSchedulePolicy = {
    MONTHLY: [
        {
            label: 'On invoice date',
            value: '0',
            frequency: 'days',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }
                return getMonthDiff(startDate, endDate, true)
            },
            getNextBillingDate: (startDate, billNum) => {
                return addMonths(startDate, billNum)
            }
        },
        {
            label: '1 week before invoice date',
            value: '1',
            frequency: 'days',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                startDate = addWeeksTo(startDate, -1)
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }

                return getMonthDiff(startDate, endDate, true)
            },
            getNextBillingDate: (startDate, billNum) => {
                return addMonths(startDate, billNum)
            }
        },
        {
            label: '2 week before invoice date',
            value: '2',
            frequency: 'days',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                startDate = addWeeksTo(startDate, -2)
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }

                return getMonthDiff(startDate, endDate, true)
            },
            getNextBillingDate: (startDate, billNum) => {
                return addMonths(startDate, billNum)
            }
        }
    ],
    QUARTERLY: [
        {
            label: 'On invoice date',
            value: '0',
            frequency: 'quarter',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }
                const duration = getMonthDiff(startDate, endDate, true)
                return Math.ceil(duration / 3) // num of quarters
            },
            getNextBillingDate: (startDate, billNum, lastBillingDate) => {
                return addMonths(lastBillingDate || startDate, billNum > 0 && 3 || 0)
            }
        },
        {
            label: '1 Month before invoice date',
            value: '1',
            frequency: 'quarter',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                startDate = addMonths(startDate, -1)
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }

                const duration = getMonthDiff(startDate, endDate, true)

                return Math.ceil(duration / 3) // num of quarters
            },
            getNextBillingDate: (startDate, billNum, lastBillingDate) => {
                startDate = addMonths(lastBillingDate || startDate, billNum > 0 && -(billNum) || -1)
                return addMonths(lastBillingDate || startDate, billNum > 0 && 3 || 0)
            }
        },
        {
            label: '2 Month before invoice date',
            value: '2',
            frequency: 'quarter',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                startDate = addMonths(startDate, -2)
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }

                const duration = getMonthDiff(startDate, endDate, true)

                return Math.ceil(duration / 3) // num of quarters
            },
            getNextBillingDate: (startDate, billNum, lastBillingDate) => {
                startDate = addMonths(lastBillingDate || startDate, billNum > 0 && -(billNum) || -2)
                return addMonths(lastBillingDate || startDate, billNum > 0 && 3 || 0)
            }
        }
    ],
    YEARLY: [
        {
            label: 'On invoice date',
            value: '0',
            frequency: 'year',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }
                const duration = getMonthDiff(startDate, endDate, true)

                return Math.ceil(duration / 12) // num of years
            },
            getNextBillingDate: (startDate, billNum) => {
                return addMonths(startDate, billNum)
            }
        },
        {
            label: '1 Month before invoice date',
            value: '1',
            frequency: 'year',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                startDate = addMonths(startDate, -1)
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }

                const duration = getMonthDiff(startDate, endDate, true)

                return Math.ceil(duration / 12) // num of years
            },
            getNextBillingDate: (startDate, billNum, lastBillingDate) => {
                startDate = addMonths(lastBillingDate || startDate, billNum > 0 && -(billNum) || -1)
                return addMonths(lastBillingDate || startDate, billNum > 0 && 3 || 0)
            }
        },
        {
            label: '2 Month before invoice date',
            value: '2',
            frequency: 'year',
            getNumOfBills: (startDate, endDate, defaultDuration = 12) => {
                startDate = addMonths(startDate, -2)
                if (!endDate) {
                    endDate = addMonths(startDate, defaultDuration)
                }

                const duration = getMonthDiff(startDate, endDate, true)

                return Math.ceil(duration / 12) // num of years
            },
            getNextBillingDate: (startDate, billNum, lastBillingDate) => {
                startDate = addMonths(lastBillingDate || startDate, billNum > 0 && -(billNum) || -2)
                return addMonths(lastBillingDate || startDate, billNum > 0 && 3 || 0)
            }
        }
    ]
}

export function buildInvoices(invoices, groups, createdBy) {

    const populateInvoice = (groups, key, invoice, populateDates = false) => {
        let totalInvoiceAmount = 0
        groups[key].forEach(schedule => {
            schedule.invoiceId = key
            totalInvoiceAmount += schedule.amount
            if (populateDates) {
                invoice['creationDate'] = schedule.billingDate
                invoice['invoiceDate'] = schedule.billingDate
            }
            if (!invoice['elements']) {
                invoice['elements'] = []
            }
            invoice['elements'].push(schedule)
            invoice['source'] = schedule.source || 'Excel'
            invoice['url'] = schedule.url || ''
        })
        invoice['totalInvoiceAmount'] = totalInvoiceAmount
    }

    Object.keys(groups).forEach(key => {
        let invoice = invoices.find(invoice => invoice['invoiceId'] == key)
        if (!invoice) {
            invoice = {
                'invoiceId': key,
                createdBy,
                'totalInvoiceAmount': 0,
                'elements': []
            }

            populateInvoice(groups, key, invoice, true)
        } else {
            populateInvoice(groups, key, invoice)
        }

        if (invoice.totalInvoiceAmount != 0)
            invoices.push(invoice)
    })
}

export function geneateBillingInvoices(salesOrder, billingPolicy, createdBy) {

    // This should generate billings in this manner:
    // Monthly: InvoiceDate: Jan - 15, DeliveryEndDate: Dec - 31
    // 12 Bills every 15th of the month

    const invoices = []
    const schedules = []

    const schedulePolicy = Object.values(billingPolicy)[0]

    const currentArrangement = salesOrder.revenueArrangement.find(revenueArrangement => revenueArrangement.state == 'Current');
    currentArrangement.revenueArrangementItem.forEach(rai => {
        schedules.push(...buildBillingPlan(salesOrder, rai.salesOrderItem.rootId || rai.salesOrderItem.id, salesOrder.invoiceDate, rai.deliveryEndDate, rai.extendedSalePrice, schedulePolicy))
    })

    const groups = Utils.groupByOnArray(schedules, s => s['billingDate'].replace(/-/g, ''))

    buildInvoices(invoices, groups, salesOrder.salesPerson && salesOrder.salesPerson.name || createdBy)

    return {
        invoices,
        schedules
    }
}


function buildBillingPlan(salesOrder, itemId, startDate, endDate, originalBooking, policy) {
    const schedules = []

    const numOfBills = policy.getNumOfBills(startDate, endDate)
    const orderItem = salesOrder.salesOrderItem.find(item => {
        const itemid = item.rootId || item.id
        if (itemid == itemId) {
            return item
        }
    })

    const product = orderItem.product
    // Spread the originalBooking to number of Biils
    let lastBillingDate
    for (let billNum = 0; billNum < numOfBills; billNum++) {

        const billingDate = policy.getNextBillingDate(startDate, billNum, lastBillingDate)

        const schedule = {}
        schedule['amount'] = originalBooking / numOfBills
        schedule['billingDate'] = billingDate
        schedule['itemId'] = itemId
        schedule['product'] = product
        schedule['index'] = billNum + 1

        lastBillingDate = billingDate

        schedules.push(schedule)
    }

    return schedules
}
